import React from "react";
import Dialog from "@mui/material/Dialog";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import { demoUser } from "../utils/StringUtils";

interface LowBalancePopupProps {
  open: boolean;
  onClose: () => void;
  walletIcon?: string;
}

const LowBalancePopup: React.FC<LowBalancePopupProps> = ({
  open,
  onClose,
  walletIcon,
}) => {
  const navigate = useNavigate();

  // Don't show popup for demo users
  if (demoUser()) {
    return null;
  }

  const handleClose = () => {
    // Mark popup as closed in sessionStorage so it won't show again
    sessionStorage.setItem("lowBalancePopupClosed", "true");
    onClose();
  };

  const handleDepositClick = () => {
    // Mark popup as closed in sessionStorage so it won't show again
    sessionStorage.setItem("lowBalancePopupClosed", "true");
    onClose();
    navigate("/wallet");
  };

  return (
    <Dialog
      fullScreen={false}
      open={open}
      onClose={handleClose}
      PaperProps={{
        style: {
          position: 'absolute',
          top: '5rem',
        },
      }}
    >
      <div className="bg-inputbox-color relative p-4 sm:p-6" style={{ minWidth: '20rem', maxWidth: '90vw', width: 'auto' }}>
        <CloseIcon
          className="absolute top-3 right-3 text-white text-2xl font-semibold cursor-pointer"
          onClick={handleClose}
        />
        <div className="text-white">
          <div className="flex justify-center mb-4">
            <AccountBalanceWalletIcon 
              style={{ 
                fontSize: '50px', 
                color: 'var(--border-color)',
                paddingTop: '0px'
              }} 
            />
          </div>
          <h2 className="text-lg sm:text-xl font-semibold mb-2 text-center">
            Low Balance Alert !
          </h2>
          <h3 className="text-sm sm:text-base font-semibold mb-4 text-center px-2">
            Your Balance Is too Low Please Deposit To Continue.
          </h3>
          <div className="flex justify-center">
            <button
              type="button"
              className="p-2.5 px-6 sm:px-8 text-sm sm:text-base text-white bg-border-color rounded-lg border border-border-color border-solid leading-[1.4rem] min-w-[120px] sm:min-w-[150px] w-full sm:w-auto max-w-[200px]"
              onClick={handleDepositClick}
            >
              Deposit
            </button>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default LowBalancePopup;

